// Permit Files Enhanced File Input Handler
document.addEventListener('turbolinks:load', function() {
  initializePermitFileHandlers();

  // Target the container where Cocoon inserts nested fields
  const container = document.querySelector('#permit-files-container');

  if (!container) {
    return;
  }

  // Initialize MutationObserver
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          const uploadContainer = node.querySelector('.upload-form.file-upload-area');
          const fileField = node.querySelector('input[type="file"]');
          const previewsContainer = node.querySelector('.file-previews');

          if (uploadContainer && fileField && previewsContainer) {
            // Small delay to ensure DOM is ready
            setTimeout(function() {
              initializeFileHandler(uploadContainer, fileField, previewsContainer);
            }, 100);
          }
        }
      });
    });
  });

  // Start observing the container for child additions
  observer.observe(container, { childList: true, subtree: true });
});

function initializePermitFileHandlers() {
  // Initialize handlers for existing permit file fields
  const permitFileForms = document.querySelectorAll('.nested-fields.form-card');
  
  permitFileForms.forEach(function(form) {
    const uploadContainer = form.querySelector('.upload-form.file-upload-area');
    const fileField = form.querySelector('input[type="file"]');
    const previewsContainer = form.querySelector('.file-previews');
    
    if (uploadContainer && fileField && previewsContainer) {
      initializeFileHandler(uploadContainer, fileField, previewsContainer);
    }
  });
}

function initializeFileHandler(container, fileField, previewsContainer) {
  // Check if there's already a file uploaded
  const existingFile = container.querySelector('.fa-file-o');
  if (existingFile) {
    // If there's an existing file, disable the dropzone and hide upload message
    container.classList.add('d-none');
    container.style.cursor = 'default';
    
    // Hide the upload message if it exists
    const uploadMessage = container.querySelector('.upload-message');
    if (uploadMessage) {
      uploadMessage.style.display = 'none';
    }
    
    // Disable only the drag and drop functionality, not the view file button
    container.removeEventListener('mousedown', container._uploadHandler);
    container.removeEventListener('dragover', container._dragOverHandler);
    container.removeEventListener('dragleave', container._dragLeaveHandler);
    container.removeEventListener('drop', container._dropHandler);
    
    return;
  }
  
  // Check if handlers are already initialized
  if (container.dataset.handlersInitialized === 'true') {
    return;
  }
  
  // Mark as initialized
  container.dataset.handlersInitialized = 'true';
  
  // Make the container clickable to trigger file input
  container.style.cursor = 'pointer';
  
  // Add click handler with a flag to prevent multiple triggers
  let isClicking = false;
  
  // Create event handlers and store references
  container._uploadHandler = function(e) {
    if (isClicking) {
      return; // Prevent multiple triggers
    }
    
    // Only trigger if clicking on the upload message area, not on previews or other elements
    if (e.target.closest('.upload-message') && !e.target.closest('.file-preview')) {
      e.preventDefault();
      e.stopPropagation();
      isClicking = true;
      
      // Use setTimeout to prevent immediate re-triggering
      setTimeout(() => {
        fileField.click();
        isClicking = false;
      }, 10);
    }
  };
  
  container._dragOverHandler = function(e) {
    e.preventDefault();
    e.stopPropagation();
    container.style.borderColor = '#5065F6';
    container.style.backgroundColor = '#F4F7FB';
  };
  
  container._dragLeaveHandler = function(e) {
    e.preventDefault();
    e.stopPropagation();
    container.style.borderColor = '#D0D7E2';
    container.style.backgroundColor = '#F9FAFB';
  };
  
  container._dropHandler = function(e) {
    e.preventDefault();
    e.stopPropagation();
    container.style.borderColor = '#D0D7E2';
    container.style.backgroundColor = '#F9FAFB';
    
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      handleFileSelection(files[0], fileField, previewsContainer);
    }
  };
  
  // Add event listeners
  container.addEventListener('mousedown', container._uploadHandler);
  container.addEventListener('dragover', container._dragOverHandler);
  container.addEventListener('dragleave', container._dragLeaveHandler);
  container.addEventListener('drop', container._dropHandler);
  
  // Handle file input change
  fileField.addEventListener('change', function(e) {
    const files = e.target.files;
    if (files.length > 0) {
      handleFileSelection(files[0], fileField, previewsContainer);
    }
  });
}

function handleFileSelection(file, fileField, previewsContainer) {
  // Validate file size
  const minimumFileSize = 200 * 1024 * 1024; // 200MB
  if (file.size > minimumFileSize) {
    alert("File size is larger than 200MB");
    return;
  }
  
  // Clear previous previews
  previewsContainer.innerHTML = '';
  
  // Create file preview
  const preview = document.createElement('div');
  preview.className = 'file-preview';
  preview.innerHTML = `
    <div class="file-details">
      <div class="file-filename">${file.name}</div>
      <div class="file-size">${formatFileSize(file.size)}</div>
    </div>
    <div class="file-remove" onclick="removeFile(this.parentNode, '${fileField.id}')">
      <i class="fa fa-times"></i>
    </div>
  `;
  
  previewsContainer.appendChild(preview);

  // Hide the upload message
  previewsContainer.parentNode.firstElementChild.style = 'display: none;';
  
  // Update the file input
  const dataTransfer = new DataTransfer();
  dataTransfer.items.add(file);
  fileField.files = dataTransfer.files;
}

// Make removeFile globally accessible
window.removeFile = function(previewElement, fileFieldId) {
  const fileField = document.getElementById(fileFieldId);
  if (fileField) {
    fileField.value = '';
  }

  const container = previewElement.parentNode.closest('.upload-form.file-upload-area');
  previewElement.remove();

  // Re-enable the upload area
  if (container) {
    container.classList.remove('has-file');
    container.style.cursor = 'pointer';
    
    // Show the upload message again
    const uploadMessage = container.querySelector('.upload-message');
    if (uploadMessage) {
      uploadMessage.style.display = 'block';
    }
    
    // Re-add event listeners if they exist
    if (container._uploadHandler) {
      container.addEventListener('mousedown', container._uploadHandler);
      container.addEventListener('dragover', container._dragOverHandler);
      container.addEventListener('dragleave', container._dragLeaveHandler);
      container.addEventListener('drop', container._dropHandler);
    }
  }
};

function formatFileSize(bytes) {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}